const rem = (value = 1) => `${value}rem`;

export { rem };
